import {Helmet} from "react-helmet-async";
import React from "react";
import ManageSiteVersion from "../../../../../components/common/builder/studies/ManageSiteVersion";

const ManageSiteVersionPage = () => {

    return (
        <>
            <Helmet title={'BUILDER :: Manage Sites'}/>
            <ManageSiteVersion />
        </>
    )
}

export default ManageSiteVersionPage;